export default {
  api: {
    url: process.env.REACT_APP_API_URL,
    token: process.env.REACT_APP_API_TOKEN,
    companyUrl: process.env.REACT_APP_API_COMPANIES_URL,
  },
  defaultParams: parseJson(process.env.REACT_APP_DEFAULT_PARAMS_MAPPING),
  gtm: {
    gtmId: process.env.REACT_APP_GTM_ID
  }
};

function parseJson(input) {
  try {
    return input ? JSON.parse(input) : {};
  } catch (e) {
    console.error("Invalid JSON:", e);
    return {};
  }
}
